import { Component, OnInit } from '@angular/core';

import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';

@Component({
  selector: 'app-no-internet',
  templateUrl: './no-internet.page.html',
  styleUrls: ['./no-internet.page.scss'],
  imports: [
    FormsModule,
    IonicModule
  ],
  host: { class: 'page-container' },
})
export class NoInternetPage implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
